import { render, staticRenderFns } from "./TermsOfUseLink.vue?vue&type=template&id=3ef041d0&"
import script from "./TermsOfUseLink.vue?vue&type=script&lang=js&"
export * from "./TermsOfUseLink.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUseLink.vue?vue&type=style&index=0&id=3ef041d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports